var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.9015C15.864 15.9015 17.375 14.4483 17.375 12.6556C17.375 10.8629 15.864 9.40967 14 9.40967C12.136 9.40967 10.625 10.8629 10.625 12.6556C10.625 14.4483 12.136 15.9015 14 15.9015Z",
    stroke: "#313234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3641 18.7762L15.5907 23.367C15.1689 23.7723 14.5969 24 14.0006 24C13.4042 24 12.8323 23.7723 12.4104 23.367L7.63588 18.7762C6.37725 17.5656 5.52013 16.0233 5.1729 14.3443C4.82567 12.6652 5.00393 10.9249 5.68513 9.34325C6.36633 7.76164 7.51989 6.40982 8.99992 5.45873C10.48 4.50764 12.22 4 14 4C15.78 4 17.5201 4.50764 19.0001 5.45873C20.4801 6.40982 21.6337 7.76164 22.3149 9.34325C22.9961 10.9249 23.1743 12.6652 22.8271 14.3443C22.4799 16.0233 21.6227 17.5656 20.3641 18.7762V18.7762Z",
    stroke: "#313234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.374d0d65.svg";
export { ForwardRef as ReactComponent };